import config from 'config'
import { resolveClientByRegion } from 'utils/region'
import urlParse from 'url-parse'
import axios from 'axios'

export const customerApiClient = axios.create({
    baseURL: config.CUSTOMER_API,
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json; charset=utf-8',
    },
})

export const customerApiEuClient = axios.create({
  baseURL: config.CUSTOMER_API_EU,
  headers: {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json; charset=utf-8',
  },
})

export const customerKongApiClient = axios.create({
  baseURL: config.KONG_CUSTOMER_API,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
  },
})

export const customerKongEuApiClient = axios.create({
  baseURL: config.KONG_CUSTOMER_API_EU,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
  },
})

export const billingApiClient = axios.create({
  baseURL: config.BILLING_API,
  headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
  },
})

export const billingApiEuClient = axios.create({
  baseURL: config.BILLING_API_EU,
  headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
  },
})

export const authApiClient = axios.create({ baseURL: config.AUTH_API })
export const authApiEuClient = axios.create({ baseURL: config.AUTH_API_EU })
export const centralAuthApiClient = axios.create({ baseURL: config.CENTRAL_AUTH_API })

export const getAuthApiClient = () => {
  const urlQueryParams = urlParse(window.location.search, true).query
  return resolveClientByRegion(urlQueryParams.region, authApiClient, authApiEuClient)
}

export const getCustomerApiClient = () => {
  const urlQueryParams = urlParse(window.location.search, true).query
  return resolveClientByRegion(urlQueryParams.region, customerApiClient, customerApiEuClient)
}

export const getCustomerKongApiClient = () => {
  const urlQueryParams = urlParse(window.location.search, true).query
  return resolveClientByRegion(urlQueryParams.region, customerKongApiClient, customerKongEuApiClient)
}

export const getBillingApiClient = () => {
  const urlQueryParams = urlParse(window.location.search, true).query
  return resolveClientByRegion(urlQueryParams.region, billingApiClient, billingApiEuClient)
}